import { render, staticRenderFns } from "./UserActivity.vue?vue&type=template&id=47046fc4&scoped=true"
import script from "./UserActivity.vue?vue&type=script&lang=js"
export * from "./UserActivity.vue?vue&type=script&lang=js"
import style0 from "./UserActivity.vue?vue&type=style&index=0&id=47046fc4&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "47046fc4",
  null
  
)

export default component.exports